/* Black Like 2026. Think Lab, 03/11/2026.
   Com 3 ou mais pecas da colecao black-like no carrinho, adiciona o mini perfume (presente, R$ 0),
   um por pedido, e tira quando a contagem cai abaixo de 3.
   Para desligar: tire o script de snippets/tl-ajustes.liquid. */
(function(){
  var COL = 'black-like';
  var VARIANTE = 67932690677869;
  var HANDLE = 'mini-perfume-black-like-presente';
  var MIN = 3;
  var handles = null, rodando = false, semEstoque = false, pendente = false;

  function j(u, o){ return fetch(u, o).then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); }); }

  function pegaHandles(){
    if (handles) return Promise.resolve(handles);
    return j('/collections/' + COL + '/products.json?limit=250').then(function(d){
      handles = {};
      (d.products || []).forEach(function(p){ handles[p.handle] = true; });
      return handles;
    }).catch(function(){ handles = null; return {}; });
  }

  function atualizaTela(linha, qtd){
    if (typeof window.getCartUpdate === 'function') { try { window.getCartUpdate(linha, qtd); return; } catch(e){} }
    return fetch('/cart/change.js', { method:'POST', __tl:true, headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: linha, quantity: qtd }) }).then(function(){ location.reload(); });
  }

  function reconcilia(){
    if (rodando) { pendente = true; return; }
    rodando = true;
    Promise.all([pegaHandles(), j('/cart.js')]).then(function(r){
      var hs = r[0], cart = r[1];
      var n = 0, linha = -1, qtd = 0;
      (cart.items || []).forEach(function(it, i){
        if (it.handle === HANDLE) { linha = i + 1; qtd += it.quantity; return; }
        if (hs[it.handle]) n += it.quantity;
      });
      var merece = n >= MIN;
      if (merece && qtd === 0 && !semEstoque) {
        return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, __tl:true,
          body: JSON.stringify({ items:[{ id: VARIANTE, quantity: 1, properties: { 'Black Like': 'Presente' } }] }) })
          .then(function(resp){
            if (!resp.ok) { semEstoque = true; return; }
            return j('/cart.js').then(function(c2){
              var l = -1; (c2.items||[]).forEach(function(it,i){ if(it.handle===HANDLE) l=i+1; });
              if (l > 0) return atualizaTela(l, 1);
            });
          });
      }
      if (!merece && qtd > 0) return atualizaTela(linha, 0);
      if (merece && qtd > 1) return atualizaTela(linha, 1);
    }).catch(function(){}).then(function(){
      rodando = false;
      if (pendente) { pendente = false; setTimeout(reconcilia, 300); }
    });
  }

  var origFetch = window.fetch;
  window.fetch = function(entrada, init){
    var url = (typeof entrada === 'string') ? entrada : (entrada && entrada.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url) && !(init && init.__tl)) {
      p.then(function(){ setTimeout(reconcilia, 300); }).catch(function(){});
    }
    return p;
  };
  document.addEventListener('cart:updated', function(){ setTimeout(reconcilia, 300); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcilia);
  else reconcilia();
})();
